export default __webpack_public_path__ + "static/media/juice-fruit-product-l-desktop@2x.71e5993a.png";